/**
 * 奇遇事件系统
 * 在不同场景随机触发事件
 */

import type { PlayerState } from './Player';
import type { GameEvent, EventChoice, EventEffect } from '../data/events';
import { EVENTS } from '../data/events';
import { ITEMS } from '../data/items';

export interface EventTriggerResult {
  event: GameEvent;
  choiceMade?: EventChoice;
  effects: EventEffect[];
  messages: string[];
}

/**
 * 检查是否触发事件
 */
export function checkEventTrigger(trigger: GameEvent['trigger'], player: PlayerState): EventTriggerResult | null {
  const candidates = EVENTS.filter((e) => e.trigger === trigger);
  if (candidates.length === 0) return null;

  for (const event of candidates) {
    if (Math.random() < event.chance) {
      return { event, effects: [], messages: [] };
    }
  }
  return null;
}

/**
 * 应用事件选择的效果
 */
export function applyEventChoice(player: PlayerState, choice: EventChoice): string[] {
  const messages: string[] = [];

  for (const effect of choice.effects) {
    switch (effect.type) {
      case 'exp':
        player.cultivationExp = Math.max(0, player.cultivationExp + effect.value);
        messages.push(effect.message);
        break;
      case 'stones':
        player.spiritStones = Math.max(0, player.spiritStones + effect.value);
        messages.push(effect.message);
        break;
      case 'hp':
        player.hp = Math.max(1, Math.min(player.maxHp, player.hp + effect.value));
        messages.push(effect.message);
        break;
      case 'mp':
        player.mp = Math.max(0, Math.min(player.maxMp, player.mp + effect.value));
        messages.push(effect.message);
        break;
      case 'damage':
        player.hp = Math.max(1, player.hp - Math.abs(effect.value));
        messages.push(effect.message);
        break;
      case 'item':
        const template = ITEMS.find((i) => i.id === effect.itemId);
        if (template) {
          player.inventory.push(JSON.parse(JSON.stringify(template)));
          messages.push(effect.message);
        }
        break;
      case 'buff_exp':
        // 简单实现：直接加经验代替持续buff
        messages.push(effect.message);
        break;
      case 'buff_breakthrough':
        // 简单实现：下次突破加成在突破时检查，此处只记录
        messages.push(effect.message);
        break;
    }
  }

  return messages;
}
